//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_STATE_LIST = 'SET_STATE_LIST';
export const CLEAR_STATE_LIST = 'CLEAR_STATE_LIST';
export const STATE_LIST_PENDING = 'STATE_LIST_PENDING';
export const STATE_LIST_ERROR = 'STATE_LIST_ERROR';
export const STATE_LIST_ERROR_CLEAR = 'STATE_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const STATE_FILTER_DIALOG_OPEN = 'STATE_FILTER_DIALOG_OPEN';
export const STATE_FILTER_DIALOG_CLOSE = 'STATE_FILTER_DIALOG_CLOSE';
export const SET_STATE_FILTER_DATA = 'SET_STATE_FILTER_DATA';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_STATE_DETAILS = 'SET_STATE_DETAILS';
export const CLEAR_STATE_DETAILS = 'CLEAR_STATE_DETAILS';
export const STATE_DETAILS_PENDING = ' STATE_DETAILS_PENDING';
export const STATE_DETAILS_ERROR = ' STATE_DETAILS_ERROR';
export const STATE_DETAILS_ERROR_CLEAR = ' STATE_DETAILS_ERROR_CLEAR';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const STATE_CREATE_DIALOG_OPEN = 'STATE_CREATE_DIALOG_OPEN';
export const STATE_CREATE_DIALOG_CLOSE = 'STATE_CREATE_DIALOG_CLOSE';
export const STATE_CREATE_PENDING = 'STATE_CREATE_PENDING';
export const STATE_CREATE_ERROR = 'STATE_CREATE_ERROR';
export const STATE_CREATE_ERROR_CLEAR = 'STATE_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const STATE_EDIT_DIALOG_OPEN = 'STATE_EDIT_DIALOG_OPEN';
export const STATE_EDIT_DIALOG_CLOSE = 'STATE_EDIT_DIALOG_CLOSE';
export const STATE_EDIT_PENDING = 'STATE_EDIT_PENDING';
export const STATE_EDIT_ERROR = 'STATE_EDIT_ERROR';
export const STATE_EDIT_ERROR_CLEAR = 'STATE_EDIT_ERROR_CLEAR';
